module.exports = __webpack_public_path__ + "../resources/img/bg_storage1_03.4d68d3ab.png";